// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1jQQT","buttons":"SendReceipts_buttons__2Bh1W","email":"SendReceipts_email__1Ud5c","bookApptTitle":"SendReceipts_bookApptTitle__1RgG9"};